webpackJsonp([114276838955818,60335399758886],{

/***/ 152:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(383);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(152);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(113);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FlatButton = function (_PureComponent) {
	  _inherits(FlatButton, _PureComponent);
	
	  function FlatButton() {
	    _classCallCheck(this, FlatButton);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  FlatButton.prototype.render = function render() {
	    return _react2.default.createElement(_Button2.default, _extends({}, this.props, { flat: true }));
	  };
	
	  return FlatButton;
	}(_react.PureComponent);
	
	FlatButton.propTypes = {
	  /**
	   * The label to display in the button.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the icon should be displayed before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * A `FontIcon` to display in the button. It can be placed before
	   * or after the label.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `FlatButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `flat`.')
	};
	FlatButton.defaultProps = {
	  type: 'button',
	  iconBefore: true
	};
	exports.default = FlatButton;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentDeprecated = __webpack_require__(113);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _IconButton = __webpack_require__(270);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A `FloatingButton` is an extension of the `IconButton`.
	 * A tooltip can be displayed on hover or touch hold if the
	 * `tooltipLabel` prop is given.
	 *
	 * Another name for this button is a `FloatingActionButton` (FAB).
	 *
	 * Any other props (such as style or event listeners) will also be
	 * applied.
	 */
	var FloatingButton = function (_PureComponent) {
	  _inherits(FloatingButton, _PureComponent);
	
	  function FloatingButton() {
	    _classCallCheck(this, FloatingButton);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  FloatingButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        fixed = _props.fixed,
	        mini = _props.mini,
	        children = _props.children,
	        iconClassName = _props.iconClassName,
	        props = _objectWithoutProperties(_props, ['className', 'fixed', 'mini', 'children', 'iconClassName']);
	
	    return _react2.default.createElement(
	      _IconButton2.default,
	      _extends({}, props, {
	        className: (0, _classnames2.default)({
	          'md-btn--floating-fixed': fixed,
	          'md-btn--floating-mini': mini
	        }, className),
	        iconClassName: iconClassName,
	        floating: true
	      }),
	      children
	    );
	  };
	
	  return FloatingButton;
	}(_react.PureComponent);
	
	FloatingButton.propTypes = {
	  /**
	   * The className to use for rendering the `FontIcon`.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to render the `FontIcon`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional label to use if you would like a tooltip to display
	   * on hover or touch hold.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * The position that the tooltip should be displayed relative to
	   * the button.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An optional amount of delay before the tooltip appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * Boolean if the floating button is fixed.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be displayed as the mini
	   * version.
	   */
	  mini: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `FloatingButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `floating`.')
	};
	exports.default = FloatingButton;

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(113);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _injectTooltip = __webpack_require__(111);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `IconButton` component automatically includes ink and a tooltip.
	 * The tooltip will only be included if the `tooltipLabel` prop is given.
	 *
	 * Any other props (such as style or event listeners) will also be
	 * applied.
	 */
	var IconButton = function (_PureComponent) {
	  _inherits(IconButton, _PureComponent);
	
	  function IconButton() {
	    _classCallCheck(this, IconButton);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  IconButton.prototype.render = function render() {
	    var _props = this.props,
	        iconClassName = _props.iconClassName,
	        children = _props.children,
	        tooltip = _props.tooltip,
	        floating = _props.floating,
	        props = _objectWithoutProperties(_props, ['iconClassName', 'children', 'tooltip', 'floating']);
	
	    delete props.tooltipLabel;
	    delete props.tooltipPosition;
	
	    return _react2.default.createElement(
	      _Button2.default,
	      _extends({}, props, { icon: !floating, floating: floating }),
	      tooltip,
	      _react2.default.createElement(
	        _FontIcon2.default,
	        { iconClassName: iconClassName },
	        children
	      )
	    );
	  };
	
	  return IconButton;
	}(_react.PureComponent);
	
	IconButton.propTypes = {
	  /**
	   * The className to use for rendering the `FontIcon`.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to render the `FontIcon`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Boolean if the IconButton is floating
	  floating: PropTypes.bool,
	   /**
	   * An optional label to use if you would like a tooltip to display
	   * on hover or touch hold.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * The position that the tooltip should be displayed relative to
	   * the button.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An optional amount of delay before the tooltip appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  // Inject from injectTooltip
	  tooltip: _propTypes2.default.node,
	  floating: _propTypes2.default.bool,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `IconButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `icon`.')
	};
	IconButton.defaultProps = {
	  type: 'button'
	};
	exports.default = (0, _injectTooltip2.default)(IconButton);

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(113);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RaisedButton = function (_PureComponent) {
	  _inherits(RaisedButton, _PureComponent);
	
	  function RaisedButton() {
	    _classCallCheck(this, RaisedButton);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  RaisedButton.prototype.render = function render() {
	    return _react2.default.createElement(_Button2.default, _extends({}, this.props, { raised: true }));
	  };
	
	  return RaisedButton;
	}(_react.PureComponent);
	
	RaisedButton.propTypes = {
	  /**
	   * The label to display in the button.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the icon should be displayed before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * A `FontIcon` to display in the button. It can be placed before
	   * or after the label.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `RaisedButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `raised`.')
	};
	RaisedButton.defaultProps = {
	  type: 'button',
	  iconBefore: true
	};
	exports.default = RaisedButton;

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = undefined;
	
	var _Button2 = __webpack_require__(19);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _FlatButton2 = __webpack_require__(577);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _RaisedButton2 = __webpack_require__(579);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _FloatingButton2 = __webpack_require__(578);
	
	var _FloatingButton3 = _interopRequireDefault(_FloatingButton2);
	
	var _IconButton2 = __webpack_require__(270);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Button3.default;
	exports.Button = _Button3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.FloatingButton = _FloatingButton3.default;
	exports.IconButton = _IconButton3.default;

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = undefined;
	
	var _NavigationDrawer2 = __webpack_require__(291);
	
	var _NavigationDrawer3 = _interopRequireDefault(_NavigationDrawer2);
	
	var _CloseButton2 = __webpack_require__(166);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _JumpToContentLink2 = __webpack_require__(290);
	
	var _JumpToContentLink3 = _interopRequireDefault(_JumpToContentLink2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavigationDrawer3.default;
	exports.NavigationDrawer = _NavigationDrawer3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.JumpToContentLink = _JumpToContentLink3.default;

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = componentDeprecated;
	/** @module utils/PropTypes/componentDeprecated */
	
	/**
	 * A simple PropType validation that shows that a component is deprecated and also prints
	 * a reason for the deprecation.
	 *
	 * @param {String} reason - The reason that the component is deprecated.
	 * @return {Error} a prop type validation error.
	 */
	function componentDeprecated(reason) {
	  return function validate(props, propName, componentName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	
	    return new Error('The `' + componentNameSafe + '` has been deprecated and will be removed in the next release. ' + reason);
	  };
	}

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Buttons = __webpack_require__(580);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SiteConfig = __webpack_require__(51);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _pdpblanco = __webpack_require__(765);
	
	var _pdpblanco2 = _interopRequireDefault(_pdpblanco);
	
	var _radioblanco = __webpack_require__(766);
	
	var _radioblanco2 = _interopRequireDefault(_radioblanco);
	
	var _iwmf = __webpack_require__(764);
	
	var _iwmf2 = _interopRequireDefault(_iwmf);
	
	__webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import UserLinks from "../UserLinks/UserLinks";
	
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    //const url = config.siteRss;
	    //const { userLinks } = this.props;
	    var copyright = _SiteConfig2.default.copyright;
	    var fixedFooter = _SiteConfig2.default.fixedFooter;
	    if (!copyright) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "footer",
	      { className: fixedFooter ? "footer footer-fixed" : "footer" },
	      _react2.default.createElement(
	        "div",
	        { className: "notice-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "logos-footer" },
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.radionacional.co/", title: "Radio Nacional" },
	            _react2.default.createElement("img", { src: _radioblanco2.default, alt: "Radio Nacional" })
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://piedepagina.mx/", title: "Pie de P\xE1gina" },
	            _react2.default.createElement("img", { src: _pdpblanco2.default, alt: "Pie de P\xE1gina" })
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.iwmf.org/", title: "International Women's Media Foundation" },
	            _react2.default.createElement("img", { src: _iwmf2.default, alt: "International Women's Media Foundation" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "copyright" },
	          _react2.default.createElement(
	            "h4",
	            null,
	            copyright
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iwmf.96c5f5dd.png";

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FontIcons = __webpack_require__(281);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GetNavList(config) {
	  var Episodes = [{
	    primaryText: "La masacre que no pudieron borrar",
	    secondaryText: "Capítulo 1",
	    leftIcon: null,
	    component: _gatsbyLink2.default,
	    to: "/la-masacre-que-no-pudieron-borrar.html"
	  }, {
	    primaryText: "Militares al banquillo",
	    secondaryText: "Capítulo 2",
	    leftIcon: null,
	    component: _gatsbyLink2.default,
	    to: "/militares-al-banquillo.html"
	  }, {
	    primaryText: "Hubo días de horror",
	    secondaryText: "Capítulo 3",
	    leftIcon: null,
	    component: _gatsbyLink2.default,
	    to: "/hubo-dias-de-horror.html"
	  }, {
	    primaryText: "Recuperar a los seres queridos, uno por uno",
	    secondaryText: "Capítulo 4",
	    leftIcon: null,
	    component: _gatsbyLink2.default,
	    to: "/recuperar-a-los-seres-queridos-uno-por-uno.html"
	  }];
	  var NavList = [{
	    primaryText: "Inicio",
	    leftIcon: null,
	    component: _gatsbyLink2.default,
	    to: "/"
	  }, {
	    primaryText: "Capítulos",
	    leftIcon: null,
	    nestedItems: Episodes
	    //component: Link,
	    //to: "/la-masacre-que-no-pudieron-borrar.html"
	  }, {
	    primaryText: "Acerca",
	    leftIcon: null,
	    component: _gatsbyLink2.default,
	    to: "/acerca/"
	  }, {
	    primaryText: "Créditos",
	    leftIcon: null,
	    component: _gatsbyLink2.default,
	    to: "/creditos/"
	  }];
	
	  NavList.push();
	  return NavList;
	}
	exports.default = GetNavList;
	module.exports = exports["default"];

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(27);
	
	var _NavigationDrawers = __webpack_require__(613);
	
	var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);
	
	var _CloseButton = __webpack_require__(166);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _NavList = __webpack_require__(380);
	
	var _NavList2 = _interopRequireDefault(_NavList);
	
	var _Footer = __webpack_require__(377);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import WeatherBtn from '../WeatherBtn/WeatherBtn'
	
	var DrawerHeaderComponent = function DrawerHeaderComponent(props) {
	  return _react2.default.createElement(
	    'div',
	    props,
	    _react2.default.createElement(_CloseButton2.default, { className: 'cr-close-drawer-btn' })
	  );
	};
	
	var HambIcon = function HambIcon() {
	  return _react2.default.createElement(
	    _reactMd.SVGIcon,
	    { size: 28 },
	    _react2.default.createElement(
	      'g',
	      { id: 'hamb', fill: '#ffffff' },
	      _react2.default.createElement('polygon', { id: 'Path', points: '0 17 28 17 28 14 0 14' }),
	      _react2.default.createElement('polygon', { id: 'Path', points: '0 10 28 10 28 7 0 7' }),
	      _react2.default.createElement('polygon', { id: 'Path', points: '0 3 28 3 28 0 0 0' })
	    )
	  );
	};
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        config = _props.config,
	        LocalTitle = _props.LocalTitle;
	
	    var footerLinks = LocalTitle !== "About";
	    return _react2.default.createElement(
	      _NavigationDrawers2.default,
	      {
	        desktopDrawerType: _reactMd.Drawer.DrawerTypes.PERSISTENT,
	        drawerZDepth: 0,
	        drawerClassName: 'cr-drawer md-grid md-grid--no-spacing'
	        //drawerHeader={<DrawerHeaderComponent className="md-cell md-cell--12" />}
	        , contentClassName: 'cr-main-content',
	        toolbarTitleClassName: 'cr-toolbar-title',
	        toolbarClassName: 'cr-toolbar',
	        toolbarZDepth: 0,
	        toolbarTitle: LocalTitle,
	        temporaryIcon: _react2.default.createElement(HambIcon, null),
	        navClassName: 'cr-nav md-cell md-cell--12',
	        className: 'cr-navigation',
	        navItems: (0, _NavList2.default)(config) },
	      _react2.default.createElement('div', { className: 'cr-background' }),
	      children,
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(268);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(559);
	
	var _Navigation = __webpack_require__(381);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _SiteConfig = __webpack_require__(51);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(566);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainLayout = function (_React$Component) {
	  _inherits(MainLayout, _React$Component);
	
	  function MainLayout() {
	    _classCallCheck(this, MainLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainLayout.prototype.getLocalTitle = function getLocalTitle() {
	    var pathPrefix = _SiteConfig2.default.pathPrefix ? _SiteConfig2.default.pathPrefix : "/";
	    var currentPath = this.props.location.pathname.replace(pathPrefix, "").replace("/", "");
	    var title = "";
	    switch (currentPath) {
	      case "":
	        title = _SiteConfig2.default.siteTitle;
	        break;
	      case "acerca":
	        title = "Acerca";
	        break;
	      case "creditos":
	        title = "Créditos";
	        break;
	      case "programacion":
	        title = "Programación";
	        break;
	      case "galeria":
	        title = "Galería";
	        break;
	      default:
	        title = _SiteConfig2.default.siteTitle;
	        break;
	    }
	    return title;
	  };
	
	  MainLayout.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      _Navigation2.default,
	      { config: _SiteConfig2.default, LocalTitle: this.getLocalTitle() },
	      children()
	    );
	  };
	
	  return MainLayout;
	}(_react2.default.Component);
	
	exports.default = MainLayout;
	module.exports = exports["default"];

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-170be04e5dfbd2286951.js